import { DEFAULT_ARCHIVE_STATUSES, DEFAULT_LIVE_STATUSES } from '@/redux/modules/search/search.types';

import { getPriceGuideBaseUrl } from '../urls';

type CategoryNode = {
    categories?: CategoryNode[];
    id: string;
    parents?: { id: string }[];
    selected?: boolean;
};

const getParentPathForQuery = (category: CategoryNode) => {
    let categoryToQuery = '';
    if (category.selected && category.parents && category.parents.length > 0) {
        let parentsToQuery = '';
        category.parents.forEach((parent) => {
            parentsToQuery += `${parent.id}/`;
        });
        categoryToQuery = `${parentsToQuery}${categoryToQuery}`;
    }
    return categoryToQuery;
};

const normalizeCategoryChildren = <Category>(
    categories: Category[] | { facets: Category[] } | null | undefined
): Category[] => {
    if (Array.isArray(categories)) {
        return categories;
    }
    if (categories?.facets) {
        return categories.facets;
    }
    return [];
};

export const concatenatePath = <Category extends CategoryNode>(
    category: Category | undefined,
    categoryId: string | number
): string | number => {
    if (!category) {
        return categoryId;
    }
    if (String(category.id) === String(categoryId)) {
        let categoryToQuery = category.id;
        categoryToQuery = `${getParentPathForQuery(category)}${categoryToQuery}`;

        return categoryToQuery;
    }
    const nextCategory = findCategoryContainingSomeCategoryId(
        categoryId,
        normalizeCategoryChildren(category.categories)
    );

    return `${category.id}/${concatenatePath(nextCategory, categoryId)}`;
};

export const findCategoryContainingSomeCategoryId = <
    Category extends { categories?: Category[] | { facets: Category[] } | null; id: string },
>(
    categoryId: string | number,
    // Accept either the flat `Category[]` shape or the wrapped `{ facets: Category[] }`.
    // search-party's /search/v4/web response nests category facets inside a `{ facets: [...] }`;
    // pre-#8439 callers used the flat shape from /search/faceted and are still valid.
    categories: Category[] | { facets: Category[] } | null | undefined
): Category | undefined => {
    const normalized = normalizeCategoryChildren(categories);
    if (normalized.length === 0) {
        return undefined;
    }
    const directMatch = normalized.find((c) => String(c.id) === String(categoryId));
    if (directMatch) {
        return directMatch;
    }
    return normalized.find((c) =>
        findCategoryContainingSomeCategoryId(categoryId, normalizeCategoryChildren(c.categories))
    );
};

export const translateStatus = (queryParams: any, pathname: string) => {
    let status = DEFAULT_LIVE_STATUSES;

    if (queryParams.status === 'archive' || (pathname && pathname.includes(getPriceGuideBaseUrl()))) {
        status = DEFAULT_ARCHIVE_STATUSES;
    }

    return status;
};

export const sortCountryFacets = (countryFacets: any) => {
    return countryFacets.sort((a, b) => {
        if (a.name > b.name) {
            return 1;
        }
        if (a.name < b.name) {
            return -1;
        }
        return 0;
    });
};
